import { useLayoutEffect, useState } from "react"
import {
    schedule_add,
    schedule_remove,
    form_save,
    grade_setup
} from "./setup"
import registerStyle from "./register.module.css"
import managerStyle from "manager/manager.module.css"
import Help2 from "../help/help2"


export default function Register() {

    const branchInfo = window.EventManager.branchInfo
    const selectEevent = window.EventManager.selectEevent
    const selectDay = window.EventManager.selectDay
    const gradeList = window.EventManager.gradeList

    const [scheduleList, Set_scheduleList]= useState([])

    useLayoutEffect(() => {
        const new_schedule = []
        if(selectDay.length === 0) {
            Set_scheduleList(new_schedule)
        }
        else if(selectDay.length === 1) {
            const schedule = window.EventManager.monthSchedule
            const day = selectDay[0]['value']
            const filter_day = schedule.filter(x => x['targetDate'] === day)

            for(let i=0; i<filter_day.length; i++) {
                new_schedule.push({
                    'set': 'edit',
                    'event_id': filter_day[i]['eventId'],
                    'schedule_id': filter_day[i]['id'],
                    'title': filter_day[i]['title'],
                    'description': filter_day[i]['description'],
                    'time': filter_day[i]['targetTime'],
                    'number': filter_day[i]['targetNumber'],
                    'grade': JSON.parse(filter_day[i]['targetGrades']),
                    'public': filter_day[i]['isPublic'],
                    'start': filter_day[i]['startAt'],
                    'end': filter_day[i]['endAt'],
                    'payment': filter_day[i]['payment']
                })
            }
            // for(let i=0; i<scheduleList.length; i++) {
            //     if(scheduleList[i]['set'] !== 'edit') {
            //         new_schedule.push(scheduleList[i])
            //     }
            // }
            Set_scheduleList(new_schedule)
        }
        else {
            for(let i=0; i<scheduleList.length; i++) {
                if(scheduleList[i]['set'] !== 'edit') {
                    new_schedule.push(scheduleList[i])
                }
            }
            Set_scheduleList(new_schedule)
        }

        if(selectDay.length !== 0 && new_schedule.length === 0) {
            schedule_add({
                scheduleList: new_schedule,
                Set_scheduleList: Set_scheduleList
            })
        }
    }, [selectDay])

    useLayoutEffect(() => {
        const register = document.getElementById('register')
        for(let i=0; i<scheduleList.length; i++) {
            const grade = register.querySelectorAll(`[set="grade"][index="${i}"]`)
            for(let j=0; j<grade.length; j++) {
                if(scheduleList[i]['grade'].includes(grade[j].value)) {
                    register.querySelector(`[set="grade"][index="${i}"][index2='${j}']`).checked = true
                }
                else {
                    register.querySelector(`[set="grade"][index="${i}"][index2='${j}']`).checked = false
                }
            }

            if(gradeList.length === scheduleList[i]['grade'].length) {
                register.querySelector(`[set="grade_all"][index="${i}"]`).checked = true
            }
            else {
                register.querySelector(`[set="grade_all"][index="${i}"]`).checked = false
            }
        }
    }, [scheduleList])

    if(selectDay.length === 0) {
        return(
            <div className={registerStyle['registerWrap']}>
                <div className={managerStyle['alarm']}>날짜를 선택해 주세요.</div>
            </div>
        )
    }
    else {
        return(
            <div
                id="register"
                className={registerStyle['registerWrap']}
            >
                <Help2
                    text="② 내용을 입력하세요."
                    on={true}
                ></Help2>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "10px"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginRight: "10px"
                            }}
                        >
                            <div
                                className={registerStyle['registered']}
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    marginRight: "5px"
                                }}
                            ></div>
                            <div
                                className={registerStyle['label']}
                            >기존 등록된 일정</div>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <div
                                className={registerStyle['new']}
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    marginRight: "5px",
                                }}
                            ></div>
                            <div
                                className={registerStyle['label']}
                            >새로 등록할 일정</div>
                        </div>
                    </div>

                    <div
                        style={{
                            position: "relative",
                        }}
                    >
                        <Help2
                            text="③ 등록하세요."
                            on={true}
                        ></Help2>

                        <button
                            type="button"
                            className={`
                                ${managerStyle['button']}
                                ${managerStyle['primary']}
                            `}
                            style={{
                                width: "70px",
                                height: "30px"
                            }}
                            onClick={() => form_save({
                                scheduleList: scheduleList,
                                Set_scheduleList: Set_scheduleList
                            })}
                        >등록</button>
                    </div>
                </div>

                <div className={registerStyle['listWrap']}>
                    {scheduleList
                    .map((value, index) => {
                        return(
                            <div
                                key={index}
                                className={
                                    (registerStyle['scheduleWrap'])
                                    + ' ' +
                                    (value['set'] === 'edit'
                                    ? registerStyle['registered']
                                    : registerStyle['new'])
                                }
                            >
                                <div
                                    style={{
                                        position: "absolute",
                                        right: "10px",
                                    }}
                                >
                                    <button
                                        type="button"
                                        className={`
                                            ${managerStyle['button']}
                                            ${managerStyle['dark']}
                                        `}
                                        style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "100%"
                                        }}
                                        onClick={(e) => schedule_remove({
                                            set: value['set'],
                                            event_id: value['event_id'],
                                            schedule_id: value['schedule_id'],
                                            index: index,
                                            scheduleList: scheduleList,
                                            Set_scheduleList: Set_scheduleList
                                        })}
                                    >x</button>
                                </div>

                                <div
                                    style={{
                                        display: "flex"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column"
                                        }}
                                    >
                                        <div className={registerStyle['propertyWrap']}>
                                            <div className={registerStyle['label']}>제목</div>
                                            <div className={registerStyle['input_text']}>
                                                <input
                                                    type="text"
                                                    value={value['title']}
                                                    onInput={(e) => {
                                                        value['title'] = e.currentTarget.value
                                                        Set_scheduleList((preState) => {
                                                            return [...preState]
                                                        })
                                                    }}
                                                ></input>
                                            </div>
                                        </div>

                                        <div className={registerStyle['propertyWrap']}>
                                            <div className={registerStyle['label']}>설명</div>
                                            <div className={registerStyle['textarea']}>
                                                <textarea
                                                    value={value['description']}
                                                    onChange={(e) => {
                                                        value['description'] = e.currentTarget.value
                                                        Set_scheduleList((preState) => {
                                                            return [...preState]
                                                        })
                                                    }}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div
                                            style={{
                                                display: "flex"
                                            }}
                                        >
                                            <div className={registerStyle['propertyWrap']}>
                                                <div className={`${registerStyle['label']} ${registerStyle['required']}`}>*시간</div>
                                                <div className={registerStyle['input_time']}>
                                                    <input
                                                        type="time"
                                                        value={value['time']}
                                                        onChange={(e) => {
                                                            value['time'] = e.currentTarget.value
                                                            Set_scheduleList((preState) => {
                                                                return [...preState]
                                                            })
                                                        }}
                                                    ></input>
                                                </div>
                                            </div>

                                            <div className={registerStyle['propertyWrap']}>
                                                <div
                                                    className={`${registerStyle['label']} ${registerStyle['required']}`}
                                                >*인원</div>
                                                <div
                                                    className={registerStyle['input_text']}
                                                    style={{
                                                        width: "60px"
                                                    }}
                                                >
                                                    <input
                                                        type="text"
                                                        maxLength={3}
                                                        value={value['number']}
                                                        onChange={(e) => {
                                                            value['number'] = e.currentTarget.value.replace(/[^0-9]/g, "")
                                                            Set_scheduleList((preState) => {
                                                                return [...preState]
                                                            })
                                                        }}
                                                    ></input>
                                                </div>
                                            </div>

                                            <div className={registerStyle['propertyWrap']}>
                                                <div className={registerStyle['label']}>공개</div>
                                                <div className={registerStyle['input_checkbox']}>
                                                    <input
                                                        type="checkbox"
                                                        checked={value['public']}
                                                        onChange={(e) => {
                                                            value['public'] = e.currentTarget.checked
                                                            Set_scheduleList((preState) => {
                                                                return [...preState]
                                                            })
                                                        }}
                                                    ></input>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                display: "none"
                                            }}
                                        >
                                            <div className={registerStyle['propertyWrap']}>
                                                <div className={registerStyle['label']}>시작일</div>
                                                <div className={registerStyle['input_date']}>
                                                    <input
                                                        type="date"
                                                        value={value['start']}
                                                        onChange={(e) => {
                                                            value['start'] = e.currentTarget.value
                                                            Set_scheduleList((preState) => {
                                                                return [...preState]
                                                            })
                                                        }}
                                                    ></input>
                                                </div>
                                            </div>

                                            <div className={registerStyle['propertyWrap']}>
                                                <div className={registerStyle['label']}>종료일</div>
                                                <div className={registerStyle['input_date']}>
                                                    <input
                                                        type="date"
                                                        value={value['end']}
                                                        onChange={(e) => {
                                                            value['end'] = e.currentTarget.value
                                                            Set_scheduleList((preState) => {
                                                                return [...preState]
                                                            })
                                                        }}
                                                    ></input>
                                                </div>
                                            </div>

                                            <div className={registerStyle['propertyWrap']}>
                                                <div
                                                    className={`${registerStyle['label']}`}
                                                >가격</div>
                                                <div
                                                    className={registerStyle['input_text']}
                                                    style={{
                                                        width: "80px",
                                                        backgroundColor: branchInfo['id'] !== '1157' ? "rgba(239, 239, 239, 0.3)" : "white",
                                                    }}
                                                >
                                                    <input
                                                        type="text"
                                                        value={value['payment']}
                                                        maxLength={7}
                                                        onChange={(e) => {
                                                            value['payment'] = e.currentTarget.value.replace(/[^0-9]/g, "")
                                                            Set_scheduleList((preState) => {
                                                                return [...preState]
                                                            })
                                                        }}
                                                        disabled={branchInfo['id'] !== '1157' ? true : false}
                                                    ></input>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                display: "flex"
                                            }}
                                        >
                                            <div className={registerStyle['propertyWrap']}>
                                                <div className={`${registerStyle['label']} ${registerStyle['required']}`}>*학년</div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexWrap: "wrap"
                                                    }}
                                                >
                                                    <label className={registerStyle['gradeButton']}>
                                                        <input
                                                            type="checkbox"
                                                            set="grade_all"
                                                            index={index}
                                                            onClick={(e) => grade_setup({
                                                                set: 'all',
                                                                index: index,
                                                                checked: e.currentTarget.checked,
                                                                scheduleList: scheduleList,
                                                                Set_scheduleList: Set_scheduleList,
                                                            })}
                                                        ></input>
                                                        <div>전체</div>
                                                    </label>
                                                    {gradeList
                                                    .map((v, i) => {
                                                        return(
                                                            <label
                                                                key={i}
                                                                className={registerStyle['gradeButton']}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    set="grade"
                                                                    index={index}
                                                                    index2={i}
                                                                    value={v['Mcode'].trim()}
                                                                    onClick={(e) => grade_setup({
                                                                        set: 'one',
                                                                        scheduleList: scheduleList,
                                                                        Set_scheduleList: Set_scheduleList,
                                                                        index: index,
                                                                        index2: i,
                                                                        checked: e.currentTarget.checked,
                                                                        value: v['Mcode'].trim()
                                                                    })}
                                                                ></input>
                                                                <div>{v['McodeName']}</div>
                                                            </label>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>

                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        height: "50px",
                        marginTop: "10px",
                        flexShrink: 0
                    }}
                >
                    <Help2
                        text="① 일정을 추가하세요."
                        on={true}
                        reverse={true}
                    ></Help2>

                    <button
                        type="button"
                        className={`
                            ${managerStyle['button']}
                            ${managerStyle['info']}
                        `}
                        style={{
                            width: "100%",
                            height: "100%",
                            fontSize: "30px"
                        }}
                        onClick={() => schedule_add({
                            scheduleList: scheduleList,
                            Set_scheduleList: Set_scheduleList
                        })}
                    >+</button>
                </div>
            </div>
        )
    }
}